import { authInstance as axios } from 'utils/axiosInterceptor';

const getAuthUser = () =>
  axios.get(`${process.env.REACT_APP_USER_ADMIN_URL}/useradmin/me`);

export default {
  getAuthUser,
};
